"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const scrollToRef = (ref) => {
    ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
};
exports.default = scrollToRef;
